/*
 *	Плагин для вывода сообщений. Основан на плагине https://github.com/HubSpot/messenger
 * 	@author Tretyakov Pavel <tretyakovpavel.ru@gmail.com>
 */
define(function (require) {
    'use strict';

    /*
     * Подключаем скрипты необходимые для плагина
     */
    var _ = require('underscore');
    var Marionette = require('marionette');
    var Backbone = require('backbone');
    require('messenger');
    require('messenger-theme');

    /*
     * @param string message - строка с сообщением
     * @return выводит сообщение об ошибке на экран с кнопкой закрытия
     */
    var error = function (message, hideAfter, options) {
        options = options || {};

        if (hideAfter == undefined) {
            hideAfter = 30
        }

        var message = Messenger().post({
            message: message,
            type: 'error',
            showCloseButton: true,
            hideAfter: hideAfter,
            id: options.id
        });

        return message;
    };

    /*
     * @param string message - строка с сообщением
     * @return выводит сообщение на экран
     */
    var success = function (message, hideAfter, hideClose, options) {
        options = options || {};
        hideClose = hideClose || false;

        if (hideAfter == undefined) {
            hideAfter = 30
        }

        var message = Messenger().post({
            showCloseButton: !hideClose,
            message: message,
            hideAfter: hideAfter,
            id: options.id,
            actions: options.actions
        });

        return message;
    };

    var custom = function (message, hideAfter, hideClose, options) {
        options = options || {};
        hideClose = hideClose || false;

        if (hideAfter == undefined) {
            hideAfter = 30
        }

        var message = Messenger().post({
            showCloseButton: !hideClose,
            message: message,
            hideAfter: hideAfter,
            id: options.id,
            actions: options.actions,
            type: 'custom',
        });

        return message;
    };

    /*
     * @param string message - строка с сообщением
     * @param function success - функция, которая выполнится в случае подтвержения
     * @return выводит сообщение на экран
     */
    var confirm = function (message, success, cancel, options) {
        options = options || {};
        var actions = {
            retry: {
                label: options.okText || 'Ок',
                action: function () {
                    success();
                    return this.cancel();
                }
            }
        };

        if (!options.hideCancel) {
            actions.cancel = {
                label: options.cancelText || 'Отмена',
                    action: function () {
                    if (cancel) {
                        cancel();
                    }

                    return this.cancel();
                }
            }
        }

        if (options.hideAfter == undefined) {
            options.hideAfter = 15
        }

        if (options.showCloseButton == undefined) {
            options.showCloseButton = true
        }

        return Messenger().post({
            showCloseButton: options.showCloseButton,
            message: message,
            type: 'error',
            hideAfter: options.hideAfter,
            actions: actions,
            id: options.id
        });
    };

    var hide = function(id) {
        var msgs = Messenger().findById(id).filter(message => message.msg.rendered && message.msg.shown);
        var result = false;

        msgs.forEach(msg => {
            msg.msg.cancel();
            result = true;
        })

        Messenger().history = _.reject(Messenger().history, function(item) {
            return item.msg.options.id == id;
        });

        return result;
    };

    var isShown = function(id) {
        return Messenger().findById(id).some(message => message.msg.rendered && message.msg.shown);
    };

    var Queue =Marionette.Object.extend({
        activeMsgId: null,

        initialize: function() {
            this.collection = new Backbone.Collection()
        },

        add: function(message) {
            var id = message.options.id;
            var activeMsg = this.activeMsgId && this.collection.get(this.activeMsgId);

            if (!id) {
                id = message.options.id = Date.now();
            }

            this.collection.add({
                id: id,
                message: message
            }, {merge: true});
            this.activeMsgId = id;
            message.on('hide', this.onHideActiveMsg, this);

            if (activeMsg) {
                activeMsg.get('message').off('hide', this.onHideActiveMsg, this);
                activeMsg.get('message').hide();
            }
        },

        onHideActiveMsg: function() {
            var nextMessage;

            this.collection.pop();
            if (this.collection.length) {
                nextMessage = this.collection.models[this.collection.length - 1];
                nextMessage.get('message').update(nextMessage.get('message').options);
                nextMessage.get('message').on('hide', this.onHideActiveMsg, this);
            }
        }
    });

    return Marionette.Object.extend({
        queues: [],

        initialize: function() {
            /*
             * Прописываем опции для плагина
             */
            window.Messenger.options = {
                maxMessages: 100,
                extraClasses: 'messenger-fixed messenger-on-bottom messenger-on-right',
                theme: 'flat'
            };
        },

        success: function(message, hideAfter, hideClose, options) {
            options = options || {};
            var msg = success(message, hideAfter, hideClose, options);
            var queue;

            if (options.queue) {
                queue = this.getQueue(options.queue);
                queue.add(msg);
            }

            return msg;
        },

        custom: function (message, hideAfter, hideClose, options) {
            options = options || {};
            var msg = custom(message, hideAfter, hideClose, options);
            var queue;

            if (options.queue) {
                queue = this.getQueue(options.queue);
                queue.add(msg);
            }

            return msg;
        },

        error: function(message, hideAfter, options) {
            if(message == 'Bad Request') return;
            options = options || {};
            var msg = error(message, hideAfter, options);
            var queue;

            if (options.queue) {
                queue = this.getQueue(options.queue);
                queue.add(msg);
            }

            return msg;
        },

        confirm: function(message, success, cancel, options) {
            options = options || {};
            var msg = confirm(message, success, cancel, options);
            var queue;

            if (options.queue) {
                queue = this.getQueue(options.queue);
                queue.add(msg);
            }

            return msg;
        },

        hide: function(id) {
            return hide(id);
        },

        isShown: function(id) {
            return isShown(id);
        },

        getQueue: function(name) {
            var queue = this.queues[name];

            if (!queue) {
                queue = this.queues[name] = new Queue();
            }

            return queue;
        }
    })
});
